<template>
  <div class="bg_white pt16 pb16">
    <SectionTitle :title="'申請完了'" :width="'121'" />
    <p class="complete_text c5a ab">申請が完了しました。</p>
    <p v-if="this.isBonus" class="complete_text_addition mxw400">
      ご登録口座へボーナス＋ウォレット出金額を一緒に振込みます。<br>
      <span class="alert">※ボーナス明細にウォレット出金額は記載されませんのであらかじめご了承ください。</span>
    </p>
    <p v-else class="complete_text_addition">
      お振り込みは3営業日ほどかかります。<br>ご登録口座にてご確認ください。
    </p>
    <div class="btn_wrap">
      <button onClick="android.close()" @click="closeWebView()" class="btn_blue ab complete_btn">確認</button>
    </div>

    <div class="bg_white pt16 pb16 boxs2 mt24">
      <SectionTitle :title="'出金確認画面'" :width="'121'" />
      <h2 class="page_title small ab ml16 mt20 mr16">出金口座情報</h2>
      <BankData :isConfirm="true" />
    </div>

    <div class="bg_white mt12 pt16 pb36">
      <h2 class="page_title ab ml16 mr16">取引明細</h2>

      <WithdrawDetail :ml="'16'" :isConfirm="true" :large="false" :orderPattern="'complete'" />
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/SectionTitle';
import BankData from '@/components/wallet/WithdrawBank';
import WithdrawDetail from '@/components/wallet/WithdrawDetail';
import { mapGetters } from 'vuex';
import close from '@/model/closeWebView'

export default {
  components: {
    SectionTitle,
    BankData,
    WithdrawDetail,
  },
  methods: {
    closeWebView() {
      // storeもデータを初期化する
      this.$store.dispatch('resetWithdrawData');
      close.closeWebView();
    }
  },
  computed: mapGetters(['isBonus'])
}
</script>

<style lang="css" scoped>
.complete_text {
  font-size: 16px;
  margin-top: 40px;
  text-align: center;
}
.btn_wrap {
  margin-top: 24px;
}

.complete_text_addition {
  font-size: 14px;
  margin: 0 auto;
  margin-top: 5px;
  padding: 0 20px;
  text-align: left;
  max-width: 290px;
}
.complete_text_addition .alert {
  font-size: 14px;
}
.complete_text_addition.mxw400 {
  max-width: 400px;
}
.alert {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/wallet/withdraw/WithdrawComplete.vue